export default __webpack_public_path__ + "static/media/3152.f71a2fd8.jpg";